import { render } from "./foto.vue?vue&type=template&id=1715c61b"
import script from "./foto.vue?vue&type=script&lang=js"
export * from "./foto.vue?vue&type=script&lang=js"

import "./foto.vue?vue&type=style&index=0&id=1715c61b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__